module.exports = __webpack_public_path__ + "img/bbq.225277bd.png";